//@flow
export const ShopWebSiteExcludedRoutes = [ '/me', '/cart', '/orders', '/account', '/account/mytryons', '/account/tryonprofile'];
export const MarketplaceExcludedRoutes = [ '/me', '/me/tryonprofile', '/cart', '/orders', '/shopping'];
export const LocalMarketExcludedRoutes = [ '/me', '/cart', '/orders', '/shopping'];
export const SellerMgmtExcludedRoutes = [ '/', '/me', '/products', '/orders'];
export const AdminMgmtExcludededRoutes = [ '/', '/me'];
